var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDomicilio = function SvgDomicilio(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#ECF0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.988 22.2222C41.2987 22.2222 42.3665 23.1154 42.3665 23.1154L57.1615 35.103C57.1615 35.103 58.0359 36.0318 57.6194 37.1154C57.2028 38.1991 55.9722 38.2022 55.9722 38.2022L54.2225 38.2222C54.2225 38.2222 54.2225 50.6666 54.2225 54.2222C54.2225 57.7777 50.667 57.7777 50.667 57.7777H47.1114C47.1114 57.7777 43.5559 57.7531 43.5544 54.2222C43.553 50.6912 43.5559 43.5555 43.5559 43.5555H36.4448C36.4448 43.5555 36.4448 50.6666 36.4448 54.1976C36.4448 57.7285 32.8892 57.7531 32.8892 57.7531H29.3336C29.3336 57.7531 25.7781 57.7777 25.7781 54.2222C25.7781 50.6666 25.7704 38.2222 25.7704 38.2222L23.9428 38.2022C23.9428 38.2022 22.6568 38.2022 22.3232 37.1154C21.9896 36.0286 22.7618 35.0956 22.7618 35.0956L37.6094 23.1154C37.6094 23.1154 38.6773 22.2222 39.988 22.2222Z",
    fill: "#498FFF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDomicilio, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/domicilio.307b1126.svg";
export { ForwardRef as ReactComponent };